var isValidType = function (data) {
    return ['string', 'number'].includes(typeof data);
};
export default (function (_a) {
    var _b = _a === void 0 ? [] : _a, text = _b[0], exp = _b[1], newSubStr = _b[2];
    if (!text || !isValidType(text) || !exp || !isValidType(exp))
        return text;
    var regexp = new RegExp(exp.toString(), 'gi');
    return text
        .toString()
        .replace(regexp, (isValidType(newSubStr) ? newSubStr : '').toString());
});
//# sourceMappingURL=rave-replace.js.map